import { Component } from "react";
import * as React from "react";
import './App.css';
import MainRouter from "./MainRouter";
import { withRouter } from "react-router";

class App extends Component<any, any> {

	public render() {
		return (
			<React.Fragment>
				<MainRouter/>
			</React.Fragment>
		);
	}
}

export default withRouter(App);
